
  <div class="background">

    <!--<img src="/public/images/background-image-3.jpg">
    
    <video loop muted autoplay oncanplay="this.play()" onloadedmetadata="this.muted = true">
      <source src="/public/images/3163534-uhd_2560_1440_30fps-576.mp4" media="(max-width: 576px)">
      <source src="/public/images/3163534-uhd_2560_1440_30fps-960.mp4" media="(min-width: 577px) and (max-width: 960px)">
      <source src="/public/images/3163534-uhd_2560_1440_30fps-1440.mp4" media="(min-width: 961px) and (max-width: 1440px)">
      <source src="/public/images/3163534-uhd_2560_1440_30fps-1920.mp4" media="(min-width: 1441px)">
      Your browser does not support the video tag.
    </video>-->

  </div>
  <div class="container">

    <div class="row">
      <div class="offset-md-2 col-md-8">
        <div class="text-center white-text">
          <h1><strong>{{creatorName}}</strong> {{'download.title' | translate }} </h1>
        </div>
       
      <mat-card class="file-download-card fade-up" style="width:100%;">
         <!--<mat-card-header>
         
         <h6><i class="fa-solid fa-folder-open" style="font-size:20px;color:#FFCE00;"></i> {{folderName}}</h6> 

        </mat-card-header>-->
        <mat-card-content>
          @if (loading) {
            <div>
              <mat-spinner></mat-spinner>
            </div>
          }
        
          <div *ngIf="!loading" >
            <mat-list >
              <ng-container *ngFor="let file of files; let i = index;">
                <mat-divider *ngIf="i > 0"></mat-divider>

                  <mat-list-item >
                    <span matListItemIcon style="margin-right:6px;">
                      <i [ngClass]="getIcon(file.name)"></i>
                    </span>
                    <div matListItemTitle>
                      <span>{{ file.name }}</span>
                    </div>
                    <span class="text-muted" matListItemMeta>
                      <small>{{ file.createdDateTime | date }} | {{ file.size | fileSize }}</small>
                      <button *ngIf="!file.isDownloading" mat-icon-button (click)="downloadFile(file)">
                        <i class="fa-regular fa-download" color="primary"></i>
                      </button>
                      <div *ngIf="file.isDownloading" class="loading-overlay">
                        <mat-spinner></mat-spinner>
                      </div>
                    </span>
                  </mat-list-item>
                 
                </ng-container>
              </mat-list>
          </div>
          <br/>
        </mat-card-content>
        <mat-card-actions>
          <!-- <button mat-stroked-button type="button">{{'download.selectButton' | translate }}</button> -->
          <button mat-flat-button color="primary" type="button" [disabled]="downloadingAll" (click)="downloadAllFiles()">{{'download.downloadAllButton' | translate }}</button>
        </mat-card-actions>
      </mat-card>
    </div>
    </div>
      
  </div>

